import type {CorePlugin} from '../../types'
import {pack} from './pack'
import {unpack} from './unpack'

export const versionPlugin = {
    name: 'VersionPlugin',
    pack,
    unpack
} satisfies CorePlugin
